import React, { Fragment } from "react";
import { round } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import className from 'classnames';
import Formatters from "../../shared/utils/Formatters";

class OverdueCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingAll: false,
    }
  }

  get sortedOverduePayments() {
    const { maxPaymentsToDisplay, overdueRepayments, sortById } = this.props;
    let payments = overdueRepayments.sort((firstLoanPlanId, secondLoanPlanId) => {
      return firstLoanPlanId.loan_plan_id - secondLoanPlanId.loan_plan_id;
    });

    if (!sortById) {
      payments = overdueRepayments
        .sort((amountA, amountB) => amountB.payment.total - amountA.payment.total)
        .sort((dateA, dateB) => moment(dateA.due_date) - moment(dateB.due_date));
    }

    if (!this.state.isShowingAll) {
      return payments.slice(0, maxPaymentsToDisplay);
    } else {
      return payments
    }
  }

  get overduePaymentCountMessage() {
    const totalLoanPlans = this.sortedOverduePayments.length;
    if (totalLoanPlans === 1) { return "You have an overdue payment" }
    if (this.props.showOverdueCount) { return `You have ${totalLoanPlans} overdue payments` }

    return "You have overdue payments"
  }

  get isRenderingViewAll() {
    const { maxPaymentsToDisplay, overdueRepayments, showViewAllButton } = this.props;
    return overdueRepayments.length > maxPaymentsToDisplay && showViewAllButton;
  }

  outstandingBalance = (payment) => {
    const rounded = round(payment.payment.total, 2);
    const amount = Formatters.currency({ amount: rounded });
    const notice = !!payment.loan_plan_id ? '*' : '';

    return `${amount}${notice}`;
  }

  renderTableHeader = () => {
    if (!this.props.showTableHeaders) { return null }

    return (
      <div className='_displayFlex _justifyContent-space-between _horizontalPadding--large-tabletUp'>
        <small className='byline _fontSize--xsmall-mobileOnly _marginBottom--xsmall'>
          LOAN ID
          </small>
        <small className='byline _fontSize--xsmall-mobileOnly _marginBottom--xsmall'>
          AMOUNT
          </small>
      </div>
    )
  }

  renderId = (payment) => {
    if (this.props.showId) { return payment.loan_plan_id }

    return Formatters.date(payment.due_date);
  }

  renderList = () => {
    const { showId } = this.props;

    return this.sortedOverduePayments.map((payment) => {
      return (
        <li key={payment.loan_plan_id} className='' style={{ paddingTop: '16px', paddingBottom: '16px', marginBottom: 0 }}>
          <div className="_displayFlex _justifyContent-space-between">
            <div className="_displayFlex _justifyContent-flex-start _alignItems-center">
              <div className="_displayFlex _justifyContent-flex-start _alignItems-center">
                <i className="materialIcon -danger --xxsmall">
                  fiber_manual_record
              </i>
                <p
                  className={className("_fontSize--small-mobileOnly -darkBlue", { '_marginRight--large': showId })}
                  data-testid='overdue-loan-plan-id'
                  style={this.props.showId ? {} : { width: '7em' }}
                >
                  <strong>
                    {this.renderId(payment)}
                  </strong>
                </p>
                <span className="ds-status -danger"> OVERDUE </span>
              </div>
            </div>
            <div className="_displayFlex _justifyContent-flex-end _alignItems-center">
              <p
                className="_fontSize--large-tabletUp _fontSize--small-mobileOnly -danger"
                data-testid='overdue-repayment-amount'
              >
                <strong>
                  {this.outstandingBalance(payment)}
                </strong>
              </p>
            </div>
          </div>
        </li>
      );
    });
  }

  renderViewAll = () => {
    if (!this.isRenderingViewAll) { return null }

    const boxShadow = this.state.isShowingAll ? '' : '0 -3em 3em white';

    return (
      <section
        data-testid="overdue-view-all-section"
        style={{ boxShadow, '-webkit-box-shadow': boxShadow, '-moz-box-shadow': boxShadow }}
        className={'cardSection -warning _textAlign_center _borderRadiusTop _displayFlex _justifyContent-center _alignItems-center'}
        onClick={this.toggleViewAll}
      >
        <p
          className="_textAlign_center -darkBlue _fontWeight--bold"
          data-testid='overdue-view-all-copy'
        >

          {this.state.isShowingAll ? 'Hide overdue payments' : 'View all overdue payments'}
        </p>
        <i
          style={{
          }}
          data-testid='overdue-view-all-toggle'
          className='materialIcon -darkBlue _marginLeft--large'
        >
          {this.state.isShowingAll ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
        </i>
      </section>
    )
  }

  renderFooterItem = () => {
    return (
      <li>
        <p className="byline _textAlign_center _fontSize--small-mobileOnly">
          {this.props.footerCopy}
        </p>
      </li>
    )
  }

  toggleViewAll = () => {
    this.setState({
      isShowingAll: !this.state.isShowingAll,
    });
  }

  render() {
    const {
      callToActionCopy,
      callToActionUrl,
      headingSubCopy,
      maxPaymentsToDisplay,
      showTableHeaders,
    } = this.props;
    const overduePayments = this.sortedOverduePayments.slice(0, maxPaymentsToDisplay);
    if (overduePayments.length === 0) return <Fragment />;

    return (
      <div className="ds-card" data-testid="overdue-card">
        <section className={className('cardSection -danger _textAlign_center _borderRadiusTop', { '_noBottomPadding': showTableHeaders })}>
          <h2 className="headline -danger">
            {this.overduePaymentCountMessage}
          </h2>
          <p className="byline _fontSize--small-mobileOnly _marginBottom--medium">
            {headingSubCopy}
          </p>
          {this.renderTableHeader()}
          {callToActionUrl && (
            <button
              data-testid="overdue-call-to-action-button"
              data-path={callToActionUrl}
              className="ds-btn -danger _displayBlock _margin--auto _marginTop--small"
              onClick={() => { window.location.href = callToActionUrl }}
            >
              {callToActionCopy}
            </button>
          )}
        </section>
        <ul className="ds-list">
          {this.renderList()}
          {!this.isRenderingViewAll && this.renderFooterItem()}
        </ul>
        {this.isRenderingViewAll && this.renderViewAll()}
        {this.isRenderingViewAll && (
          <ul className="ds-list">
            {this.renderFooterItem()}
          </ul>
        )}
      </div>
    );
  }
}

OverdueCard.defaultProps = {
  callToActionCopy: null,
  callToActionUrl: null,
  headingSubCopy: "Payments may take 1-2 banking days to process. Please disregard if you have already made payment.",
  footerCopy: "*This amount does not include additional fees yet. Contact us to know the exact amount you need to pay. We only show up to 6 overdue payments here.",
  maxPaymentsToDisplay: 6,
  overdueRepayments: [],
  showId: true,
  showOverdueCount: true,
  showTableHeaders: true,
  showViewAllButton: false,
  sortById: true,
}

OverdueCard.propTypes = {
  /** Copy for CTA button */
  callToActionCopy: PropTypes.string,
  /** URL for CTA button */
  callToActionUrl: PropTypes.string,
  /** Sub-copy to display below overdue count */
  headingSubCopy: PropTypes.string,
  /** Maximum number of payments to display */
  maxPaymentsToDisplay: PropTypes.number,
  /** Array of overdue payments */
  overdueRepayments: PropTypes.arrayOf(PropTypes.shape({
    clearance: PropTypes.string,
    created_at: PropTypes.string,
    due_date: PropTypes.string,
    loan_plan_id: PropTypes.number,
    payment: PropTypes.shape({
      fee: PropTypes.number,
      interest: PropTypes.number,
      principal: PropTypes.number,
      total: PropTypes.number,
    }),
    status: PropTypes.string,
    updated_at: PropTypes.string,
  })),
  /** Toggle for displaying loan plan id or due date as row identifier */
  showId: PropTypes.bool,
  /** Toggle for displaying overdue count in header */
  showOverdueCount: PropTypes.bool,
  /** Toggle for displaying table header */
  showTableHeaders: PropTypes.bool,
  /** Toggle for displaying view all payments */
  showViewAllButton: PropTypes.bool,
  /** Toggle for sorting by loan plan id or due date + amount */
  sortById: PropTypes.bool,
}

export default OverdueCard;



// WEBPACK FOOTER //
// ./src/features/home/components/OverdueCard.js